(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[705],{

/***/ 7484:
/***/ (function(module) {

!function(t,e){ true?module.exports=e():0}(this,(function(){"use strict";var t=1e3,e=6e4,n=36e5,r="millisecond",i="second",s="minute",u="hour",a="day",o="week",f="month",h="quarter",c="year",d="date",$="Invalid Date",l=/^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/,y=/\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,M={name:"en",weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_")},m=function(t,e,n){var r=String(t);return!r||r.length>=e?t:""+Array(e+1-r.length).join(n)+t},g={s:m,z:function(t){var e=-t.utcOffset(),n=Math.abs(e),r=Math.floor(n/60),i=n%60;return(e<=0?"+":"-")+m(r,2,"0")+":"+m(i,2,"0")},m:function t(e,n){if(e.date()<n.date())return-t(n,e);var r=12*(n.year()-e.year())+(n.month()-e.month()),i=e.clone().add(r,f),s=n-i<0,u=e.clone().add(r+(s?-1:1),f);return+(-(r+(n-i)/(s?i-u:u-i))||0)},a:function(t){return t<0?Math.ceil(t)||0:Math.floor(t)},p:function(t){return{M:f,y:c,w:o,d:a,D:d,h:u,m:s,s:i,ms:r,Q:h}[t]||String(t||"").toLowerCase().replace(/s$/,"")},u:function(t){return void 0===t}},v="en",D={};D[v]=M;var p=function(t){return t instanceof _},S=function t(e,n,r){var i;if(!e)return v;if("string"==typeof e){var s=e.toLowerCase();D[s]&&(i=s),n&&(D[s]=n,i=s);var u=e.split("-");if(!i&&u.length>1)return t(u[0])}else{var a=e.name;D[a]=e,i=a}return!r&&i&&(v=i),i||!r&&v},w=function(t,e){if(p(t))return t.clone();var n="object"==typeof e?e:{};return n.date=t,n.args=arguments,new _(n)},O=g;O.l=S,O.i=p,O.w=function(t,e){return w(t,{locale:e.$L,utc:e.$u,x:e.$x,$offset:e.$offset})};var _=function(){function M(t){this.$L=S(t.locale,null,!0),this.parse(t)}var m=M.prototype;return m.parse=function(t){this.$d=function(t){var e=t.date,n=t.utc;if(null===e)return new Date(NaN);if(O.u(e))return new Date;if(e instanceof Date)return new Date(e);if("string"==typeof e&&!/Z$/i.test(e)){var r=e.match(l);if(r){var i=r[2]-1||0,s=(r[7]||"0").substring(0,3);return n?new Date(Date.UTC(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)):new Date(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)}}return new Date(e)}(t),this.$x=t.x||{},this.init()},m.init=function(){var t=this.$d;this.$y=t.getFullYear(),this.$M=t.getMonth(),this.$D=t.getDate(),this.$W=t.getDay(),this.$H=t.getHours(),this.$m=t.getMinutes(),this.$s=t.getSeconds(),this.$ms=t.getMilliseconds()},m.$utils=function(){return O},m.isValid=function(){return!(this.$d.toString()===$)},m.isSame=function(t,e){var n=w(t);return this.startOf(e)<=n&&n<=this.endOf(e)},m.isAfter=function(t,e){return w(t)<this.startOf(e)},m.isBefore=function(t,e){return this.endOf(e)<w(t)},m.$g=function(t,e,n){return O.u(t)?this[e]:this.set(n,t)},m.unix=function(){return Math.floor(this.valueOf()/1e3)},m.valueOf=function(){return this.$d.getTime()},m.startOf=function(t,e){var n=this,r=!!O.u(e)||e,h=O.p(t),$=function(t,e){var i=O.w(n.$u?Date.UTC(n.$y,e,t):new Date(n.$y,e,t),n);return r?i:i.endOf(a)},l=function(t,e){return O.w(n.toDate()[t].apply(n.toDate("s"),(r?[0,0,0,0]:[23,59,59,999]).slice(e)),n)},y=this.$W,M=this.$M,m=this.$D,g="set"+(this.$u?"UTC":"");switch(h){case c:return r?$(1,0):$(31,11);case f:return r?$(1,M):$(0,M+1);case o:var v=this.$locale().weekStart||0,D=(y<v?y+7:y)-v;return $(r?m-D:m+(6-D),M);case a:case d:return l(g+"Hours",0);case u:return l(g+"Minutes",1);case s:return l(g+"Seconds",2);case i:return l(g+"Milliseconds",3);default:return this.clone()}},m.endOf=function(t){return this.startOf(t,!1)},m.$set=function(t,e){var n,o=O.p(t),h="set"+(this.$u?"UTC":""),$=(n={},n[a]=h+"Date",n[d]=h+"Date",n[f]=h+"Month",n[c]=h+"FullYear",n[u]=h+"Hours",n[s]=h+"Minutes",n[i]=h+"Seconds",n[r]=h+"Milliseconds",n)[o],l=o===a?this.$D+(e-this.$W):e;if(o===f||o===c){var y=this.clone().set(d,1);y.$d[$](l),y.init(),this.$d=y.set(d,Math.min(this.$D,y.daysInMonth())).$d}else $&&this.$d[$](l);return this.init(),this},m.set=function(t,e){return this.clone().$set(t,e)},m.get=function(t){return this[O.p(t)]()},m.add=function(r,h){var d,$=this;r=Number(r);var l=O.p(h),y=function(t){var e=w($);return O.w(e.date(e.date()+Math.round(t*r)),$)};if(l===f)return this.set(f,this.$M+r);if(l===c)return this.set(c,this.$y+r);if(l===a)return y(1);if(l===o)return y(7);var M=(d={},d[s]=e,d[u]=n,d[i]=t,d)[l]||1,m=this.$d.getTime()+r*M;return O.w(m,this)},m.subtract=function(t,e){return this.add(-1*t,e)},m.format=function(t){var e=this,n=this.$locale();if(!this.isValid())return n.invalidDate||$;var r=t||"YYYY-MM-DDTHH:mm:ssZ",i=O.z(this),s=this.$H,u=this.$m,a=this.$M,o=n.weekdays,f=n.months,h=function(t,n,i,s){return t&&(t[n]||t(e,r))||i[n].substr(0,s)},c=function(t){return O.s(s%12||12,t,"0")},d=n.meridiem||function(t,e,n){var r=t<12?"AM":"PM";return n?r.toLowerCase():r},l={YY:String(this.$y).slice(-2),YYYY:this.$y,M:a+1,MM:O.s(a+1,2,"0"),MMM:h(n.monthsShort,a,f,3),MMMM:h(f,a),D:this.$D,DD:O.s(this.$D,2,"0"),d:String(this.$W),dd:h(n.weekdaysMin,this.$W,o,2),ddd:h(n.weekdaysShort,this.$W,o,3),dddd:o[this.$W],H:String(s),HH:O.s(s,2,"0"),h:c(1),hh:c(2),a:d(s,u,!0),A:d(s,u,!1),m:String(u),mm:O.s(u,2,"0"),s:String(this.$s),ss:O.s(this.$s,2,"0"),SSS:O.s(this.$ms,3,"0"),Z:i};return r.replace(y,(function(t,e){return e||l[t]||i.replace(":","")}))},m.utcOffset=function(){return 15*-Math.round(this.$d.getTimezoneOffset()/15)},m.diff=function(r,d,$){var l,y=O.p(d),M=w(r),m=(M.utcOffset()-this.utcOffset())*e,g=this-M,v=O.m(this,M);return v=(l={},l[c]=v/12,l[f]=v,l[h]=v/3,l[o]=(g-m)/6048e5,l[a]=(g-m)/864e5,l[u]=g/n,l[s]=g/e,l[i]=g/t,l)[y]||g,$?v:O.a(v)},m.daysInMonth=function(){return this.endOf(f).$D},m.$locale=function(){return D[this.$L]},m.locale=function(t,e){if(!t)return this.$L;var n=this.clone(),r=S(t,e,!0);return r&&(n.$L=r),n},m.clone=function(){return O.w(this.$d,this)},m.toDate=function(){return new Date(this.valueOf())},m.toJSON=function(){return this.isValid()?this.toISOString():null},m.toISOString=function(){return this.$d.toISOString()},m.toString=function(){return this.$d.toUTCString()},M}(),b=_.prototype;return w.prototype=b,[["$ms",r],["$s",i],["$m",s],["$H",u],["$W",a],["$M",f],["$y",c],["$D",d]].forEach((function(t){b[t[1]]=function(e){return this.$g(e,t[0],t[1])}})),w.extend=function(t,e){return t.$i||(t(e,_,w),t.$i=!0),w},w.locale=S,w.isDayjs=p,w.unix=function(t){return w(1e3*t)},w.en=D[v],w.Ls=D,w.p={},w}));

/***/ }),

/***/ 1913:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/apps",
      function () {
        return __webpack_require__(2294);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 3868:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e_": function() { return /* binding */ isNew; },
/* harmony export */   "FT": function() { return /* binding */ canIUseWebp; }
/* harmony export */ });
/* unused harmony export sortBy */
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_0__);

function isNew(date) {
    var published = dayjs__WEBPACK_IMPORTED_MODULE_0___default()(date);
    var dayRange = "30";
    var cutoffDate = dayjs__WEBPACK_IMPORTED_MODULE_0___default()().subtract(dayRange, 'days');
    return published.isAfter(cutoffDate);
}
// Lodash doesn't support custom sort functions[0], so we have to do it manually[1,2]
// [0] https://github.com/lodash/lodash/pull/3764 (merged, but not released in 4.17.15)
// [1] https://github.com/you-dont-need/You-Dont-Need-Lodash-Underscore#_sortby-and-_orderby
// [2] https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/localeCompare
function sortBy(key) {
    return function(a, b) {
        return a[key].localeCompare(b[key], 'de', {
            sensitivity: 'base'
        });
    };
}
// Detect WebP support in the browser
function canIUseWebp() {
    if (false) {}
    var support = true;
    try {
        var canvas = document.createElement('canvas');
        if (!!(canvas.getContext && canvas.getContext('2d'))) {
            support = canvas.toDataURL('image/webp').indexOf('data:image/webp') === 0;
        }
    } catch (err) {
        support = false;
    }
    return support;
}


/***/ }),

/***/ 1728:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9666);

var logger = {};
logger.log = function(message) {
    (0,_sentry_nextjs__WEBPACK_IMPORTED_MODULE_0__/* .captureMessage */ .uT)(message);
    console.log(message);
    return message;
};
logger.error = function(error) {
    (0,_sentry_nextjs__WEBPACK_IMPORTED_MODULE_0__/* .captureException */ .Tb)(error);
    return error.message || error;
};
/* harmony default export */ __webpack_exports__["Z"] = (logger);


/***/ }),

/***/ 2294:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Apps; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(6486);
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(7484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 25 modules
var esm = __webpack_require__(6730);
// EXTERNAL MODULE: ./node_modules/next-auth/client.js
var client = __webpack_require__(7459);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(4184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/lib/logger.js
var logger = __webpack_require__(1728);
// EXTERNAL MODULE: ./src/components/layout.js + 2 modules
var layout = __webpack_require__(7850);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
// EXTERNAL MODULE: ./src/helpers/HelperFunctions.js
var HelperFunctions = __webpack_require__(3868);
;// CONCATENATED MODULE: ./src/components/apps/AppTemplate.js






var AppTemplate = function(param) {
    var app = param.app, _locale = param.locale, locale = _locale === void 0 ? "de" : _locale;
    var ref, ref1, ref2, ref3;
    var t = (0,esm/* useTranslation */.$G)('apps').t;
    var cardClasses = classnames_default()('col-12 col-md-6', {
        'col-xl-4': !app.isOwned
    });
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: cardClasses,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "card card-fill",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "card-body mt-0",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                            href: "/apps/".concat(encodeURIComponent(app.slug)),
                            children: ((ref = app.logo) === null || ref === void 0 ? void 0 : ref.formats) ? // App Logo
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: "card-app-logo mb-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: ((ref1 = app.logo.formats.small) === null || ref1 === void 0 ? void 0 : ref1.url) || ((ref2 = app.logo.formats.thumbnail) === null || ref2 === void 0 ? void 0 : ref2.url),
                                    className: "product-img",
                                    alt: app.name
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: "card-app-logo mb-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: app.partner.logo.formats.thumbnail.url,
                                    className: "product-img",
                                    alt: app.name
                                })
                            })
                        }),
                        ((ref3 = app.category) === null || ref3 === void 0 ? void 0 : ref3.name) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "badge bg-primary-soft mb-3",
                            children: app.category.name
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                            className: "card-title",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                    href: "/apps/".concat(encodeURIComponent(app.slug)),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "d-block hyphen",
                                        children: app.name
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                    className: "text-muted",
                                    children: app.partner.name
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "card-text small",
                            children: app["description_short_".concat(locale)]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "card-footer card-footer-boxed",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row align-items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col",
                                children: [
                                    app.coming_soon && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "badge badge-soft-secondary",
                                        children: "Coming soon"
                                    }),
                                    !app.coming_soon && (0,HelperFunctions/* isNew */.e_)(app.published_at) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "badge badge-soft-success",
                                        children: t('new')
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col-auto",
                                children: [
                                    app.isOwned && /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        href: app.app_url || '#',
                                        className: "btn btn-success",
                                        target: "_blank",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                className: "fe fe-external-link mr-1"
                                            }),
                                            " ",
                                            t('open')
                                        ]
                                    }),
                                    !app.isOwned && /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                        href: "/apps/".concat(encodeURIComponent(app.slug)),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: "btn btn-primary btn-sm",
                                            children: t('details')
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    }));
};
/* harmony default export */ var apps_AppTemplate = (AppTemplate);

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
;// CONCATENATED MODULE: ./src/components/apps/AppLoadingState.js



var AppLoadingState = function(param) {
    var iteration = param.iteration;
    var TextTemplate = function() {
        var sizes = [
            4,
            3,
            5,
            1,
            6,
            2,
            4,
            3,
            5,
            6,
            4,
            6,
            2,
            4,
            1,
            5,
            4,
            6,
            3,
            7,
            3,
            2,
            4,
            3,
            1
        ];
        var start = iteration * 5 % sizes.length;
        var textSizes = lodash_default().concat(lodash_default().slice(sizes, start), lodash_default().slice(sizes, 0, start));
        return textSizes.map(function(size, index) {
            /*#__PURE__*/ return (0,jsx_runtime.jsx)("span", {
                className: "placeholder col-".concat(size, " mr-1")
            }, index);
        });
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "col-12 col-md-6 col-xl-4",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "card card-fill",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "card-body mt-0",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                            src: "/img/logo.png",
                            alt: "placeholder",
                            className: "blur",
                            width: 100,
                            height: 32
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            className: "card-title placeholder-glow h1",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "placeholder col-8"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "card-text small placeholder-glow",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextTemplate, {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "card-footer card-footer-boxed",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row align-items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-6"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-6",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "#",
                                    tabIndex: "-1",
                                    className: "btn btn-primary btn-sm disabled placeholder d-block"
                                })
                            })
                        ]
                    })
                })
            ]
        })
    }));
};
/* harmony default export */ var apps_AppLoadingState = (AppLoadingState);

;// CONCATENATED MODULE: ./src/pages/apps/index.js












function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var __N_SSG = true;
function Apps(param) {
    var apps = param.apps, partners = param.partners, categories = param.categories, locale = param.locale;
    // Check if props are present
    if (!apps) {
        return null;
    }
    var t = (0,esm/* useTranslation */.$G)('apps').t;
    var ref7 = _slicedToArray((0,client.useSession)(), 2), session = ref7[0], loading = ref7[1];
    var ref1 = (0,react.useState)([]), appListOwned = ref1[0], setAppListOwned = ref1[1];
    var ref2 = (0,react.useState)([]), appListOther = ref2[0], setAppListOther = ref2[1];
    var ref3 = (0,react.useState)([]), filteredAppListOwned = ref3[0], setFilteredAppListOwned = ref3[1];
    var ref4 = (0,react.useState)([]), filteredAppListOther = ref4[0], setFilteredAppListOther = ref4[1];
    var ref5 = (0,react.useState)(categories), appCategories = ref5[0], setAppCategories = ref5[1];
    var ref6 = (0,react.useState)(partners), appPartners = ref6[0], setAppPartners = ref6[1];
    var loadingAppClasses = classnames_default()({
        'd-none': !loading
    });
    var handleCategoryChange = function(categoryId) {
        var updatedAppCategories = appCategories.map(function(category) {
            if (category.id === categoryId) {
                category.checked = !category.checked;
            }
            return category;
        });
        setAppCategories(updatedAppCategories);
    };
    var handlePartnerChange = function(partnerId) {
        var updatedAppPartners = appPartners.map(function(partner) {
            if (partner.id === partnerId) {
                partner.checked = !partner.checked;
            }
            return partner;
        });
        setAppPartners(updatedAppPartners);
    };
    (0,react.useEffect)(function() {
        var filterCategories = function filterCategories(appList, categoryIds) {
            if (!categoryIds || lodash_default().isEmpty(categoryIds)) return appList;
            return lodash_default().filter(appList, function(app) {
                var ref;
                return lodash_default().includes(categoryIds, (ref = app.category) === null || ref === void 0 ? void 0 : ref.id);
            });
        };
        var filterPartners = function filterPartners(appList, partnerIds) {
            if (!partnerIds || lodash_default().isEmpty(partnerIds)) return appList;
            return lodash_default().filter(appList, function(app) {
                return lodash_default().includes(partnerIds, app.partner.id);
            });
        };
        if (lodash_default().isEmpty(appListOwned) && lodash_default().isEmpty(appListOther)) return;
        // When appCategories or appPartners change, update displayed apps
        var activeCategorieIds = [];
        var activePartnerIds = [];
        lodash_default().each(appCategories, function(category) {
            if (category.checked) {
                activeCategorieIds.push(category.id);
            }
        });
        lodash_default().each(appPartners, function(partner) {
            if (partner.checked) {
                activePartnerIds.push(partner.id);
            }
        });
        setFilteredAppListOwned(filterCategories(filterPartners(appListOwned, activePartnerIds), activeCategorieIds));
        setFilteredAppListOther(filterCategories(filterPartners(appListOther, activePartnerIds), activeCategorieIds));
    }, [
        appListOther,
        appCategories,
        appPartners
    ]);
    (0,react.useEffect)(function() {
        function getOwnedApps() {
            return _getOwnedApps.apply(this, arguments);
        }
        function _getOwnedApps() {
            _getOwnedApps = _asyncToGenerator(runtime_default().mark(function _callee() {
                var ownedAppIds, filterAppsWithActiveContracts, isOwned, contracts1, res, ownedAppList, otherAppList;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            filterAppsWithActiveContracts = function _filterAppsWithActiveContracts(contracts) {
                                return contracts.reduce(function(appIds, contract) {
                                    if (contract.accepted && !dayjs_min_default()().isAfter(dayjs_min_default()(contract.expires))) {
                                        appIds.push(contract.app.id);
                                    }
                                    return appIds;
                                }, []);
                            };
                            isOwned = function _isOwned(app) {
                                return ownedAppIds.indexOf(app.id) >= 0;
                            };
                            ownedAppIds = [];
                            ;
                            ;
                            contracts1 = [];
                            _ctx.prev = 6;
                            _ctx.next = 9;
                            return fetch("".concat("https://hyapp.de", "/api/group/contracts"));
                        case 9:
                            res = _ctx.sent;
                            _ctx.next = 12;
                            return res.json();
                        case 12:
                            contracts1 = _ctx.sent;
                            if (lodash_default().has(contracts1, 'data') && !lodash_default().isEmpty(contracts1.data)) {
                                contracts1 = contracts1.data;
                                ownedAppIds = filterAppsWithActiveContracts(contracts1);
                            }
                            _ctx.next = 19;
                            break;
                        case 16:
                            _ctx.prev = 16;
                            _ctx.t0 = _ctx["catch"](6);
                            logger/* default.error */.Z.error(_ctx.t0);
                        case 19:
                            ownedAppList = [];
                            otherAppList = [];
                            apps.forEach(function(app) {
                                if (isOwned(app)) {
                                    app.isOwned = true;
                                    var contract = lodash_default().first(lodash_default().filter(contracts1, {
                                        'app': {
                                            id: app.id
                                        }
                                    }));
                                    app.app_url = (contract === null || contract === void 0 ? void 0 : contract.app_url) || app.app_url;
                                    // setAppListOwned(list => [...list, app]);
                                    ownedAppList.push(app);
                                } else {
                                    app.isOwned = false;
                                    // setAppListOther(list => [...list, app]);
                                    otherAppList.push(app);
                                }
                            });
                            setAppListOwned(ownedAppList);
                            setAppListOther(otherAppList);
                        case 24:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        6,
                        16
                    ]
                ]);
            }));
            return _getOwnedApps.apply(this, arguments);
        }
        if (session) {
            getOwnedApps();
        } else {
            setAppListOther(apps);
            setFilteredAppListOther(apps);
        }
    }, [
        session === null || session === void 0 ? void 0 : session.cmsId
    ]);
    var displayAppsLoading = function() {
        return [
            1,
            2,
            3
        ].map(function(index) {
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(apps_AppLoadingState, {
                iteration: index
            }, "loading-".concat(index));
        });
    };
    var displayLOGEXBanner = function(owned) {
        var cardClasses = classnames_default()('col-12 col-md-6', {
            'col-xl-8': !owned
        });
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: cardClasses,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "card",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: "https://logex.com/de/losungen/financial-analytics/kalkulation-padiatrie/",
                    target: "_blank",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "/img/logex/logex-kinder-versorgung.png",
                        className: "img-fluid rounded"
                    })
                })
            })
        }));
    };
    var displayApps = function(appList) {
        if (!appList) return null;
        return appList.map(function(app, index) {
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(apps_AppTemplate, {
                app: app,
                locale: locale
            }, index);
        });
    };
    var displayCategoryFilter = function() {
        return appCategories.map(function(category, index) {
            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                className: "custom-control custom-checkbox checklist-control",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "checkbox",
                        className: "custom-control-input",
                        id: "category-".concat(index),
                        value: category.name,
                        checked: category.checked,
                        onChange: function() {
                            return handleCategoryChange(category.id);
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        className: "custom-control-label",
                        htmlFor: "category-".concat(index),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "custom-control-caption",
                            children: category.name
                        })
                    })
                ]
            }, index);
        });
    };
    var displayPartnerFilter = function() {
        return appPartners.map(function(partner, index) {
            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                className: "custom-control custom-checkbox checklist-control",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "checkbox",
                        className: "custom-control-input",
                        id: "partner-".concat(index),
                        value: partner.name,
                        checked: partner.checked,
                        onChange: function() {
                            return handlePartnerChange(partner.id);
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        className: "custom-control-label",
                        htmlFor: "partner-".concat(index),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "custom-control-caption",
                            children: partner.name
                        })
                    })
                ]
            }, index);
        });
    };
    var resetFilters = function() {
        var resetAppCategories = categories.map(function(category) {
            return _objectSpread({}, category, {
                checked: false
            });
        });
        var resetAppPartners = partners.map(function(partner) {
            return _objectSpread({}, partner, {
                checked: false
            });
        });
        setAppCategories(resetAppCategories);
        setAppPartners(resetAppPartners);
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* default */.Z, {
        title: t('apps'),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "container",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "row",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "d-none d-lg-block col-lg-3 mt-6",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "card",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "card-header",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                            className: "card-header-title",
                                            children: "Filter"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            onClick: function() {
                                                return resetFilters();
                                            },
                                            className: "small",
                                            children: "Alle l\xf6schen"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "card-body pt-3",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "dropdown-header text-muted px-0 mb-2",
                                            children: "Kategorien"
                                        }),
                                        displayCategoryFilter()
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "card-body border-top pt-3",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "dropdown-header text-muted px-0 mb-2",
                                            children: "Partner"
                                        }),
                                        displayPartnerFilter()
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col-12 col-lg-9",
                        children: [
                            session && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    !lodash_default().isEmpty(filteredAppListOwned) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "header-body mb-4",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                    className: "header-title",
                                                    children: t('my-apps')
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "row",
                                                children: [
                                                    displayLOGEXBanner(true),
                                                    displayApps(filteredAppListOwned)
                                                ]
                                            })
                                        ]
                                    }),
                                    !lodash_default().isEmpty(filteredAppListOther) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "header-body mb-4",
                                                children: [
                                                    !lodash_default().isEmpty(filteredAppListOwned) && /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                        className: "header-title",
                                                        children: t('more-apps')
                                                    }),
                                                    lodash_default().isEmpty(filteredAppListOwned) && /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                        className: "header-title",
                                                        children: t('apps')
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "row",
                                                children: displayApps(filteredAppListOther)
                                            })
                                        ]
                                    })
                                ]
                            }),
                            !session && !loading && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "header-body mb-4",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                            className: "header-title",
                                            children: t('apps')
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "row",
                                        children: [
                                            displayLOGEXBanner(false),
                                            displayApps(filteredAppListOther)
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: loadingAppClasses,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "header-body mb-4",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                            className: "header-title",
                                            children: t('apps')
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "row",
                                        children: displayAppsLoading()
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    }));
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [662,706,850,774,888,179], function() { return __webpack_exec__(1913); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);